import {
  type CrossSellWidgetType,
  getIsBuyTogetherWidget,
} from 'shared/utils/crosssell'
import { type FeaturesToggles } from 'types/shopConfig'
import { isAdServerEnabled } from 'views/utils/featureToggleUtils'

export const isRetailMediaAdServerEnabled = ({
  widgets,
  wid,
  adServerCrossSellWidgetIds,
  featureToggles,
}: {
  widgets: CrossSellWidgetType
  wid: string
  adServerCrossSellWidgetIds: number[]
  featureToggles: FeaturesToggles
}): boolean => {
  const isBuyTogetherWidget = getIsBuyTogetherWidget(Number(wid), widgets)

  // Field defined on BuyTogether x-sell to determine the type of x-sell.
  // We don't want any Ad-server changes happening in BuyTogethers atm.
  return (
    !isBuyTogetherWidget &&
    isAdServerEnabled(featureToggles) &&
    // Fetch the widget from ad-server api only for specific wid
    adServerCrossSellWidgetIds.includes(Number(wid))
  )
}
